import { DomainBranding } from '@rygen/rygen-ui/model';

export class DomainPopulatorRequest {
  createNewClient: boolean;
  domainType: string;
  clientName: string | undefined;
  domainBranding?: DomainBranding;

  constructor(opts?: Partial<DomainPopulatorRequest>) {
    this.createNewClient = opts?.createNewClient ?? true;
    this.domainType = opts?.domainType ?? 'CLIENT';
    this.clientName = opts?.clientName;
    this.domainBranding = opts?.domainBranding;
  }
}
